export default {
  hero: {
    title: 'Quantum Data',
    description: `Speed up research by downloading and sharing impactful quantum datasets that are tailored to use with PennyLane.`,
    link: {
      text: `What is a Quantum Dataset?`,
      url: `/what-is-a-quantum-dataset`,
    },
  },
  metadata: {
    title: 'Quantum Data — PennyLane',
    description:
      'Explore and download our collection of quantum data. Including molecules, circuits, parameters, spin systems, and more.',
    image: 'https://assets.cloud.pennylane.ai/datasets/landing_page/Datasets_OpenGraph_New_2024-02-20.png',
  },
}
